import { ProductNode } from '../../product-listing-page/types';
import { ProductService } from './wishlist-types';

export default function productServiceProductToProductNode(product: ProductService): ProductNode {
  return {
    __typename: 'ProductNode',
    id: window.btoa(product.gid),
    images: {
      __typename: 'Images',
      edges: product.images.map((imageUrl) => {
        return {
          __typename: 'ImagesEdge',
          node: {
            __typename: 'ImageNode',
            originalSrc: imageUrl,
          },
        };
      }),
    },
    tags: product.tags,
    title: product.title,
    productType: product.productType,
    priceRange: {
      __typename: 'PriceRange',
      maxVariantPrice: {
        __typename: 'VariantPrice',
        amount: product.priceRange.maxVariantPrice.amount.toString(),
      },
      minVariantPrice: {
        __typename: 'VariantPrice',
        amount: product.priceRange.minVariantPrice.amount.toString(),
      },
    },
    compareAtPriceRange: {
      __typename: 'PriceRange',
      maxVariantPrice: {
        __typename: 'VariantPrice',
        amount: product.compareAtPriceRange.maxVariantPrice.amount.toString(),
      },
      minVariantPrice: {
        __typename: 'VariantPrice',
        amount: product.compareAtPriceRange.minVariantPrice.amount.toString(),
      },
    },
    availableColors: null,
    onlineStoreUrl: product.onlineStoreUrl,
    availableForSale: product.availableForSale,
    handle: product.handle,
    totalInventory: product.totalInventory,
    vendor: '',
    options: product.options,
  };
}
